import { z } from "zod";
const teammatePlaybookCoachingManagerInputIdSchema = z.uuid().brand();
function asTeammatePlaybookCoachingManagerInputId(id) {
  return teammatePlaybookCoachingManagerInputIdSchema.parse(id);
}
const COACHING_MANAGER_NOTE_MAX_LENGTH = 500;
const saveCoachingManagerInputRequestSchema = z.object({
  period_id: z.string().min(1),
  criterion_id: z.uuid().optional(),
  note: z.string().trim().max(COACHING_MANAGER_NOTE_MAX_LENGTH).optional().transform((value) => value ? value : void 0)
}).refine((value) => value.criterion_id || value.note, {
  message: "Either criterion_id or note is required"
});
export {
  COACHING_MANAGER_NOTE_MAX_LENGTH,
  asTeammatePlaybookCoachingManagerInputId,
  saveCoachingManagerInputRequestSchema,
  teammatePlaybookCoachingManagerInputIdSchema
};
//# sourceMappingURL=teammatePlaybookCoachingManagerInput.js.map
